import * as zoid from 'zoid';
/**
 * Zoid Widget
 * @param data details of the cross domain config tag, url, dimensions, props
 */
const ZoidWidgetInit = (data: any) => {
  const { tag, url, dimensions, props } = data;
  return zoid.create({
    tag,
    url,
    dimensions,
    props,
  });
};

export default ZoidWidgetInit;
